import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/rankings", label: "综合榜单" },
  { to: "/guide", label: "避雷指南" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-background-50"
      }`}
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-display text-xl text-foreground-950">
            漫界<span className="text-primary-500">指南</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`rounded-full px-4 py-2 text-sm transition-colors ${
                location.pathname === l.to
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/rankings"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-trophy-line"></i>
            查看排行榜
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`block rounded-lg px-3 py-2.5 text-sm ${
                location.pathname === l.to ? "bg-primary-100 text-primary-700" : "text-foreground-800"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/rankings"
            className="mt-2 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50"
          >
            <i className="ri-trophy-line"></i>
            查看排行榜
          </Link>
        </div>
      )}
    </header>
  );
}